import React, { ReactElement, useState, useEffect } from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import styled from "styled-components";
import { useTranslation } from "@coworker/locales";
interface HalfSheetProps {
  title: string;
  children: React.ReactNode;
  trigger: React.ReactNode;
  isFullWidth?: boolean | undefined;
  header?: ReactElement | null;
  footer?: ReactElement | null;
  isOpen: boolean;
  onToggle: () => void; // Optional prop for controlled component
}

const HeaderWrapper = styled(FixaModalHeader)`
  border-bottom: 1px solid #dfdfdf;
`;

const FullWidthBody = styled(FixaModalBody)`
  width: 100%;
  padding: 0;
`;

export const SimpleControlledHalfSheet: React.FC<HalfSheetProps> = ({
  title,
  children,
  trigger,
  isFullWidth = false,
  header,
  footer,
  onToggle,
  isOpen,
}) => {
  const [inTransition, setInTransition] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleTransitionAsync = async () => {
      if (isOpen) {
        setInTransition(true);
      } else {
        await new Promise((resolve) => setTimeout(resolve, 200));
        setInTransition(false);
      }
    };

    handleTransitionAsync();
  }, [isOpen]);

  if (!isOpen && !inTransition) return <div onClick={onToggle}>{trigger}</div>;

  const BodyComponent = isFullWidth ? FullWidthBody : FixaModalBody;
  return (
    <>
      {trigger}
      <FixaModal visible={isOpen} handleCloseBtn={onToggle}>
        <FixaSheets
          alignment="right"
          preserveAlignment={false}
          size="small"
          fullSize
          header={
            <>
              <HeaderWrapper
                title={t(title)}
                floating={false}
                closeBtnClick={onToggle}
              />
              {header ?? <></>}
            </>
          }
          footer={footer ?? <></>}
        >
          <BodyComponent>{children}</BodyComponent>
        </FixaSheets>
      </FixaModal>
    </>
  );
};
